export function Name<T extends Record<string, unknown>>(
  key: keyof T,
  order: "asc" | "desc" = "asc"
): (a: T, b: T) => number {
  return function innerSort(a: T, b: T): number {
    if (
      !Object.prototype.hasOwnProperty.call(a, key) ||
      !Object.prototype.hasOwnProperty.call(b, key)
    ) {
      return 0;
    }

    const varA = typeof a[key] === "string" ? (a[key] as string).toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? (b[key] as string).toUpperCase() : b[key];

    let comparison = 0;
    if ((varA as unknown as number) > (varB as unknown as number)) {
      comparison = 1;
    } else if ((varA as unknown as number) < (varB as unknown as number)) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}

export function getEmail(): string | null {
  const email = localStorage.getItem("EMAIL");
  // return email;
  return email;
}

export function getSenderEmail(): string | null {
  const email = localStorage.getItem("SENDER_EMAIL");
  //return email;
  return email;
}

export function getUserId(): string | null {
  const userId = localStorage.getItem("User_ID");
  return userId;
}
export function getSubTeamId(): string | null {
  const Id = localStorage.getItem("TEAM_SUB_ID");
  return Id;
}
export function getProfilePic(): string | null {
  const pic = localStorage.getItem("PROFILE_PIC");
  return pic;
}

export function getTeamID(): string | null {
  const teamId = localStorage.getItem("Team_ID");
  return teamId;
}

export function getBrandLogo(): string | null {
  const brandLogo = localStorage.getItem("BRAND_LOGO");
  return brandLogo;
}

export type UserRole = "Super Admin" | "Admin" | "Team Member";

/**
 * Returns the current user's role string from localStorage, or "" if unset.
 *
 * Returns a plain `string` (not `string | null`) because callers overwhelmingly
 * use the result in string-only contexts (`.includes()`, `===`, ternary).
 * An empty string fails all role comparisons identically to `null`, so this is
 * lossless. For sites that need strict narrowing to UserRole, use `getRoleNarrowed()`.
 */
export function getRole(): string {
  const role = localStorage.getItem("USER_ROLE");
  return role ?? "";
}

/** Narrowed variant for sites that need a typed UserRole (or null when unset/unknown). */
export function getRoleNarrowed(): UserRole | null {
  const r = localStorage.getItem("USER_ROLE");
  if (r === "Super Admin" || r === "Admin" || r === "Team Member") return r;
  return null;
}
export function getLoginName(): string | null {
  const name = localStorage.getItem("LOGIN_NAME");
  return name;
}
export function getFullYear(): number {
  return new Date().getFullYear();
  // return "2021";
}

export function getInvoiceCount(): number {
  const count = localStorage.getItem("INVOICE_COUNT");
  return parseInt(count ?? "");
}
export function getApprovalAmount(): number {
  const count = localStorage.getItem("APPROVAL_AMOUNT");
  return parseInt(count ?? "");
}
export function getIsAddSupplier(): string | null {
  const isAddSupplier = localStorage.getItem("isAddSupplier");
  return isAddSupplier;
}
// Common Table Sorting Method
const desc = <T extends Record<string, unknown>>(a: T, b: T, orderBy: keyof T): number => {
  const av = a[orderBy] as unknown as number;
  const bv = b[orderBy] as unknown as number;
  if (bv < av) {
    return -1;
  }
  if (bv > av) {
    return 1;
  }
  return 0;
};

export const stableSort = <T>(array: T[], cmp: (a: T, b: T) => number): T[] => {
  const stabilizedThis: Array<[T, number]> = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

export const getSorting = <T extends Record<string, unknown>>(
  order: "asc" | "desc",
  orderBy: keyof T
): ((a: T, b: T) => number) => {
  return order === "desc"
    ? (a: T, b: T) => desc(a, b, orderBy)
    : (a: T, b: T) => -desc(a, b, orderBy);
};

export const JSONParser = <T = unknown>(str: unknown, def: T): T => {
  try {
    if (str === null || str === undefined) return def;
    if (typeof str === "object") return ((str as T) ?? def) as T;
    return (JSON.parse(str as string) as T) ?? def;
  } catch {
    return def;
  }
};

export const twoFAuth = (): string | null => {
  return localStorage.getItem("AUTH_2F");
};
